(function(){
  if(window.__sfPdp){return;}
  window.__sfPdp=true;

  function fmt(n){return '₹'+Math.round(n).toLocaleString('en-IN');}
  function all(r,s){return [].slice.call(r.querySelectorAll(s));}

  /* ---------- Timeline: 5 second auto advance, loops ---------- */
  function initTimeline(root){
    if(root.__sf){return;}
    root.__sf=true;
    var stops=all(root,'.sf-tl-stop'), cards=all(root,'.sf-tl-card');
    var fill=root.querySelector('.sf-tl-fill'), prog=root.querySelector('.sf-tl-prog');
    var n=stops.length, cur=0, timer=null, visible=false, DELAY=5000;
    function runProg(on){
      if(!prog){return;}
      prog.classList.remove('run');
      void prog.offsetWidth;
      if(on){prog.classList.add('run');}
    }
    function go(i){
      cur=i;
      stops.forEach(function(s,k){
        s.classList.toggle('is-on',k===i);
        s.classList.toggle('is-done',k<i);
        s.setAttribute('aria-selected',k===i?'true':'false');
      });
      cards.forEach(function(c,k){c.classList.toggle('is-on',k===i);});
      if(fill){fill.style.width=(n>1?(i/(n-1))*(100-100/n):0)+'%';}
      runProg(!!timer);
    }
    function stop(){if(timer){clearInterval(timer);timer=null;}runProg(false);}
    function start(){
      if(timer){clearInterval(timer);}
      timer=setInterval(function(){go((cur+1)%n);},DELAY);
      runProg(true);
    }
    stops.forEach(function(s,k){
      s.addEventListener('click',function(){go(k);if(visible){start();}});
    });
    go(0);
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          visible=e.isIntersecting;
          if(visible){start();}else{stop();}
        });
      },{threshold:.4}).observe(root);
    }else{visible=true;start();}
    document.addEventListener('visibilitychange',function(){
      if(document.hidden){stop();}else if(visible){start();}
    });
  }

  /* ---------- Pack picker + Buy 2 Get 2 card (default ON) ---------- */
  function initOffer(root){
    if(root.__sf){return;}
    var sec=root.closest('section')||document;
    var pv=sec.querySelector('product-variants');
    var radios=pv?all(pv,'input.product-variant__input'):[];
    var qty=sec.querySelector('.qty-selector');
    var cards=all(root,'[data-pack]');
    if(!radios.length||!qty||!cards.length){return;}
    root.__sf=true;
    var sw=root.querySelector('[data-sw]'), sum=root.querySelector('[data-sum]');
    var slots=all(root,'[data-slot]'), b2=root.querySelector('[data-b2g2]');
    var sel=0;

    function curQty(){return Math.max(1,parseInt(qty.value,10)||1);}

    function syncFromTheme(){
      var checked=radios.filter(function(r){return r.checked;})[0];
      if(!checked){return;}
      cards.forEach(function(c,i){if(c.getAttribute('data-value')===checked.value){sel=i;}});
    }

    function setQty(target){
      var plus=sec.querySelector('.qty-plus'), minus=sec.querySelector('.qty-minus'), g=0;
      while(curQty()<target&&plus&&g++<10){plus.click();}
      while(curQty()>target&&minus&&g++<10){minus.click();}
      if(curQty()!==target){
        qty.value=target;
        qty.dispatchEvent(new Event('input',{bubbles:true}));
        qty.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }

    function render(){
      var c=cards[sel], p=parseFloat(c.getAttribute('data-price')), d=parseInt(c.getAttribute('data-days'),10);
      var q=curQty(), on=q>=2;
      cards.forEach(function(x,i){
        x.classList.toggle('is-on',i===sel);
        x.setAttribute('aria-checked',i===sel?'true':'false');
      });
      if(sw){sw.setAttribute('aria-checked',on?'true':'false');}
      if(b2){b2.classList.toggle('is-on',on);}
      slots.forEach(function(s,i){
        s.classList.toggle('is-live',on||i===0);
        var lab=s.querySelector('i'); if(lab){lab.textContent=d+' days';}
      });
      if(!sum){return;}
      if(on){
        var free=2*Math.floor(q/2), total=q+free, nights=total*d, pay=q*p;
        sum.innerHTML='You pay <b>'+fmt(pay)+'</b> for <b>'+total+' packs</b> ('+nights+' days). That is only <b>'+fmt(pay/nights)+' a day</b>. <span class="g">You save '+fmt(free*p)+'.</span>';
      }else{
        sum.innerHTML='1 x <b>'+d+' day pack</b> for <b>'+fmt(p)+'</b> ('+fmt(p/d)+' a day). Switch on <b>Buy 2, Get 2 Free</b> to get 4 packs for '+fmt(2*p)+'.';
      }
    }

    cards.forEach(function(c,i){
      c.addEventListener('click',function(){
        sel=i;
        var v=c.getAttribute('data-value');
        radios.forEach(function(r){if(r.value===v&&!r.checked){r.click();}});
        render();
      });
    });
    if(sw){
      sw.addEventListener('click',function(){
        setQty(curQty()>=2?1:2);
        render();
      });
    }
    ['.qty-plus','.qty-minus'].forEach(function(s){
      var b=sec.querySelector(s);
      if(b){b.addEventListener('click',function(){setTimeout(render,0);});}
    });
    qty.addEventListener('input',render);
    qty.addEventListener('change',render);

    /* default ON: start with quantity 2 */
    if(curQty()<2){qty.value=2;}
    syncFromTheme();
    sec.classList.add('sf-has-packs');
    render();
    function ensureOn(){
      if(root.__defaulted){return;}
      root.__defaulted=true;
      if(curQty()<2){setQty(2);}
      render();
    }
    if(document.readyState==='complete'){setTimeout(ensureOn,0);}else{window.addEventListener('load',ensureOn);}
  }

  function boot(){
    all(document,'[data-sf-timeline]').forEach(initTimeline);
    all(document,'[data-sf-offer]').forEach(initOffer);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  window.addEventListener('load',boot);
  document.addEventListener('shopify:section:load',function(){
    all(document,'[data-sf-timeline],[data-sf-offer]').forEach(function(e){e.__sf=false;e.__defaulted=false;});
    boot();
  });
})();